<template>
    <div>
        <Header v-bind:title="'就医记录'" v-bind:back="false"></Header>
        <van-row style="height:40px;line-height:40px;font-size:14px;color:#7d7e80">
            <van-col span="6" align="center" style="position:relative;"><span @click="$refs.DatePicker.show = true">查询<van-icon name="filter-o" style="position:absolute;top:11px;"/></span></van-col>
            <van-col span="18" align="center"><span @click="$refs.DatePicker.show = true">{{search.start}} 至 {{search.end}}</span></van-col>
        </van-row>
        <van-tabs v-model="active" swipeable sticky color="#26a2ff">
            <van-tab title="门诊记录">
                <van-list
                        v-model="mzjl.loading"
                        :finished="mzjl.finished"
                        :finished-text="mzjl.list.length > 0 ? '已全部加载' : '无门诊记录'"
                        @load="getMzjl()">
                    <van-cell-group v-for="(item,index) in mzjl.list" :key="item.jzlsh">
                        <van-cell center :title="item.jzlsh" :value="item.ksmc"  is-link :to="'/mzjl/'+Base64.encodeURI(JSON.stringify(item))">
                            <template slot="label">
                                <span>医生:{{item.ysmc}}</span><br>
                                <span>日期:{{item.jzrq}}</span><br>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-list>
            </van-tab>
            <van-tab title="住院记录">
                <van-list
                        v-model="zyjl.loading"
                        :finished="zyjl.finished"
                        :finished-text="zyjl.list.length > 0 ? '已全部加载' : '无住院记录'"
                        @load="getZyjl()">
                    <van-cell-group v-for="(item,index) in zyjl.list" :key="item.jzlsh">
                        <van-cell center :title="item.ssmc ? item.ssmc : item.jzlsh" is-link :to="'/zyjl/'+Base64.encodeURI(JSON.stringify(item))">
                            <template slot="label">
                                <span><span style="color:#393939">入院日期：</span>{{item.ryrq}}</span><br>
                                <span><span style="color:#393939">入院诊断：</span>{{item.ryzd}}</span><br>
                                <span><span style="color:#393939">出院诊断：</span>{{item.cyzd}}</span><br>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-list>
            </van-tab>
        </van-tabs>
        <DatePicker ref="DatePicker" v-on:listenDatePickerEvent="searchList" v-bind:startProp="search.start" v-bind:endProp="search.end"></DatePicker>
        <!--<MzjlMx ref="MzjlMx" v-bind:row="item"></MzjlMx>-->
    </div>
</template>
<script type="text/ecmascript-6">
    import Header from './components/Header.vue'
    import DatePicker from './components/DatePicker.vue'
    import MzjlMx from './mzjl-xx.vue'
    import {findMzjl,findZyjl} from '@/api/biApi.js'
    let moment = require("moment");
    let Base64 = require('js-base64').Base64;

    export default{
        name:'',
        components:{Header,DatePicker,MzjlMx},
        data(){
            return {
                Base64:Base64,
                search:{
                    mdmid:'',
                    start:'',
                    end:''
                },
                active:'',
                mzjl:{
                    loading:false,
                    finished:false,
                    page:0,
                    list:[],
                },
                zyjl:{
                    loading:false,
                    finished:false,
                    page:0,
                    list:[]
                },
                pageSize:15,
                item:'',
            }
        },
        mounted(){
            let info = this.$cookies.get('LOGIN_INFO')
            this.search.mdmid = info && info.mdmId ? info.mdmId : ''

            let end = new Date();
            let start = new Date();
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 365)
            this.search.start = moment(start).format('YYYY-MM-DD')
            this.search.end   = moment(end).format('YYYY-MM-DD')
        },
        methods:{
            openMz(item){
                this.item = item
                this.$refs.MzjlMx.show = true
            },
            searchList(start,end){
                this.search.start = start
                this.search.end   = end

                this.mzjl.list = [];
                this.zyjl.list = [];
                this.mzjl.page = 0;
                this.zyjl.page = 0;
                this.getMzjl(0)
                this.getZyjl(0)
            },
            getMzjl(){
                this.mzjl.page += 1
                findMzjl({
                    "mmid":this.search.mdmid,
                    "startDate":this.search.start,
                    "endDate":this.search.end,
                    "size":this.pageSize,
                    "page":this.mzjl.page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        res.list.map((val,index)=>{
                            this.mzjl.list.push(val)
                        })
                    }
                    if(!res || res.list.length < 15 ){
                        this.mzjl.finished = true;
                    }
                    this.mzjl.loading = false;
                }).catch(err=>{
                    this.$toast('获取失败');
                    this.mzjl.loading = false;
                    this.mzjl.finished = true;
                })
            },
            getZyjl(){
                this.zyjl.page += 1
                findZyjl({
                    "mmid":this.search.mdmid,
                    "startDate":this.search.start,
                    "endDate":this.search.end,
                    "size":this.pageSize,
                    "page":this.mzjl.page
                }).then(res=>{
                    //console.log(res)
                    if(res && res.list.length > 0){
                        res.list.map((val,index)=>{
                            this.zyjl.list.push(val)
                        })
                    }
                    if(!res || res.list.length < 15 ){
                        this.zyjl.finished = true;
                    }
                    this.zyjl.loading = false;
                }).catch(err=>{
                    this.$toast('获取失败');
                    this.zyjl.loading = false;
                    this.zyjl.finished = true;
                })
            },
            openMzjlMx(item){
                this.item = item
                this.$refs.MzjlMx.show = true
            },
            openZyjlMx(item){
                this.item = item
            },
        }
    }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/mobile/jyjl.vue